import { useStreamingFeatureCollection } from './useStreamingFeatureCollection';

export function useStreamingFeatureCollections(search, sort, filter) {
  const externalVehicles = useStreamingFeatureCollection(
    'external/vehicles',
    search.externalVehicles,
    sort.externalVehicles,
    filter.externalVehicles,
  );
  const externalPeople = useStreamingFeatureCollection(
    'external/people',
    search.externalPeople,
    sort.externalPeople,
    filter.externalPeople,
  );

  return {
    featureCollections: {
      externalVehicles,
      externalPeople,
    },
    filterValues: {
      externalVehicles: {},
      externalPeople: {},
    },
  };
}
